// ── Panorama intro animation config ───────────────────────────────────────────
// Edit these values to fine-tune the intro timing.

module.exports = {
   // Playback speed multiplier for the Lottie animation.
   // 1 = normal, 2 = twice as fast, 0.5 = half speed.
   animationSpeed: 1.5,

   // Pause between animation end and start of fade-out (milliseconds).
   // 0 = fade starts immediately when animation ends.
   fadeOutDelay: 500,

   // How long the fade-out takes (milliseconds).
   fadeOutDuration: 300,

   // CSS easing for the fade-out. E.g. 'ease-in', 'ease', 'linear'.
   fadeOutEasing: 'ease-in',
};
